import { render, staticRenderFns } from "./customer-statement-v3.vue?vue&type=template&id=a48fcfc4&scoped=true&"
import script from "./customer-statement-v3.vue?vue&type=script&lang=js&"
export * from "./customer-statement-v3.vue?vue&type=script&lang=js&"
import style0 from "./customer-statement-v3.vue?vue&type=style&index=0&id=a48fcfc4&scoped=true&lang=css&"
import style1 from "./customer-statement-v3.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48fcfc4",
  null
  
)

export default component.exports